import { Geometry } from "app/bundles/requests/shared/models/geometry";
import {
  Properties,
  RawProperties,
} from "app/bundles/requests/shared/models/properties";

export class Feature {
  type: string;
  geometry: Geometry;
  properties: Properties;
}

export class RawFeature {
  type: string;
  geometry: Geometry;
  properties: RawProperties;
}
